// The service worker (public/sw.js), registered, and what the page does when
// it says a new build has been deployed.

import { markStale } from "./api.ts";

/** How long after opening a page still counts as just opened: a reload then
 *  costs nobody anything they were in the middle of. */
const JUST_OPENED_MS = 6000;

export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator) || location.protocol !== "https:" && location.hostname !== "127.0.0.1" && location.hostname !== "localhost") return;
  let touched = false;
  const touch = () => (touched = true);
  for (const type of ["pointerdown", "keydown"]) addEventListener(type, touch, { once: true, capture: true });
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data?.type !== "blundermine-updated") return;
    // Opened a moment ago and not yet touched: take the new build now.
    // Otherwise at the next move to another screen, which replaces what is
    // on it anyway.
    if (!touched && performance.now() < JUST_OPENED_MS) location.reload();
    else markStale();
  });
  // A worker's messages wait until the page says it is listening.
  navigator.serviceWorker.startMessages();
  addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
